<template>
  <!-- <div class="FleetWebbg"> -->
    <div class="SettingBox">
      <div class="SettingBoxHeader d-flex justify-content-center align-items-center">
        {{$Global.langObj[$Global.lang].setting}}
        <i @click="GotoBack('cancel')" class="fa fa-times" style="position:absolute;right:10px;color:white;font-size:27.5px;cursor:pointer"></i>
      </div>
      <div class="SettingBody p-5">
        <div v-if="CurrentPageCheck()" class="d-flex p-0 m-0 w-100">
          <div class="p-1 m-0 d-flex justify-content-start align-items-center"><font class="font-purple">{{$Global.langObj[$Global.lang].language}}</font></div>
          <div class="col m-0"><hr class="font-purple"  /></div>
        </div>
        <select v-if="CurrentPageCheck()"  @change="ChangeLang()" class="global-select" v-model="lang">
          <option value="zh-tw">中文</option>
          <option value="en-us">English</option>
          <!-- <option value="fr-FR">français</option> -->
          <option value="ja-JP">日本語</option>
          <option value="es-MX">Español</option>
          <!-- <option value="es-ES">Español</option> -->
        </select>
        <div class="d-flex p-0 m-0 w-100">
          <div class="p-1 m-0 d-flex justify-content-start align-items-center"><font class="font-purple">{{$Global.langObj[$Global.lang].units_of_Length}}</font></div>
          <div class="col m-0"><hr class="font-purple"  /></div>
        </div>
        <select class="global-select" v-model="Unit">
          <option value="km">{{$Global.langObj[$Global.lang].kilometer}}</option>
          <option value="mi">{{$Global.langObj[$Global.lang].Mile_mi}}</option>
        </select>
        <div class="d-flex p-0 m-0 w-100">
          <div class="p-1 m-0 d-flex justify-content-start align-items-center"><font class="font-purple">{{$Global.langObj[$Global.lang].date_Format}}</font></div>
          <div class="col m-0"><hr class="font-purple"  /></div>
        </div>
        <select class="global-select" v-model="$Global.timeformat">
          <option value="YYYY/MM/DD">YYYY/MM/DD</option>
          <option value="MM/DD/YYYY">MM/DD/YYYY</option>
          <option value="DD/MM/YYYY">DD/MM/YYYY</option>
        </select>
        <div class="d-flex p-0 m-0 w-100">
          <div class="p-1 m-0 d-flex justify-content-start align-items-center"><font class="font-purple">{{$Global.langObj[$Global.lang].page_Style}}</font></div>
          <div class="col m-0"><hr class="font-purple"  /></div>
        </div>
        <select class="global-select" v-model="$Global.theme">
          <option value="white">{{$Global.langObj[$Global.lang].light_Color}}</option>
          <option value="black">{{$Global.langObj[$Global.lang].dark_Color}}</option>
        </select>
        <button @click="GotoBack('ok')" class="global-btn mt-4">{{$Global.langObj[$Global.lang].oK}}</button>
      </div>
    </div>
  <!-- </div> -->
</template>

<script>
export default {
  name: 'Setting',
  inject:['reload'],
  data () {
    return {
      lang:'en-us',//預設語言
      Unit:'km',
      Unit_local:''
    }
  },
  watch:{
  },
  mounted(){
    this.getLocalStorage()
  },
  methods:{
    CurrentPageCheck(){
      if(this.$Global.CurrentPage == 'Login'){
        return true
      }else{
        return false
      }
    },
    ChangeLang(){
      // this.$Global.ChangeLangNum++;
      // //目前跟先前的語系相同 更換次數改為0
      // setTimeout(() => {
      //   if(localStorage.getItem('Lang') == this.$Global.lang){ 
      //     this.$Global.ChangeLangNum = 0;
      //   }
      // }, 1000);
    },
    getLocalStorage(){
      //預設語言
        if(localStorage.getItem('Lang') == 'null'){
          this.lang = 'en-us'
          localStorage.setItem('Lang','en-us')
        }else{
          this.lang = localStorage.getItem('Lang')
        }
        if(localStorage.getItem('Unit') == 'null'){
          this.Unit = 'km'
          localStorage.setItem('Unit','km')
        }else{
          this.Unit = localStorage.getItem('Unit')
        }
        if(localStorage.getItem('theme') == 'null'){
          this.$Global.theme = 'black'
          localStorage.setItem('theme','black')
        }else{
          this.$Global.theme = localStorage.getItem('theme')
        }
        this.gettimeformat(localStorage.getItem('timeformat'))
    },
    gettimeformat(timeformat){
      switch (timeformat) {
        case 'YYYY/MM/DD':
          localStorage.setItem('timeformat','YYYY/MM/DD')
          this.$Global.timeformat = timeformat
          break;
        case 'MM/DD/YYYY':
          localStorage.setItem('timeformat','MM/DD/YYYY')
          this.$Global.timeformat = timeformat
          break;
        case 'DD/MM/YYYY':
          localStorage.setItem('timeformat','DD/MM/YYYY')
          this.$Global.timeformat = timeformat
          break;      
        default:
          localStorage.setItem('timeformat','YYYY/MM/DD')
          this.$Global.timeformat = 'YYYY/MM/DD'
          break;
      }
    },
    SelectUnits(){
      if(this.Unit == 'km'){
        localStorage.setItem('Unit','km')
        this.Unit = this.$Global.langObj[this.$Global.lang].kM
        this.Unit_local = 'km'
      }else{
        localStorage.setItem('Unit','mi')
        this.Unit = this.$Global.langObj[this.$Global.lang].mile
        this.Unit_local = 'mi'
      }
    },
    SelectLang(){
      // this.$APIjs.GetLang(this.lang)//lang
      // var Managelang = ''
      // switch (this.lang) {
      //   case 'en-us':
      //     Managelang = 'en-US'
      //     break;
      //   case 'zh-tw':
      //     Managelang = 'zh-TW'
      //     break;      
      //   default:
      //     Managelang = 'en-US'
      //     break;
      // }
      // this.$APIjs.GetManageLang(Managelang)
    },
    GotoBack(status){
      switch (status) {
        case 'ok':
          //設定語系
          this.$Global.lang = this.lang
          localStorage.setItem('Lang',this.lang)
          //設定語系
          this.$Global.ChangeManageMenuLang()
          // this.SelectLang()
          //設定速度單位
          this.SelectUnits()
          this.$Global.Unit_local = this.Unit_local
          this.$Global.Unit = this.Unit
          //設定時間格式
          localStorage.setItem('timeformat',this.$Global.timeformat)
          this.$Global.SettingSubmit++
          //reload PlayBackData
          this.$History.ChangePlayBackData()
          //設定背景
          this.$Global.SetTheme(this.$Global.theme)
          this.$Global.SetThemeNum++;
          switch (this.$Global.MapType) {
            case 'Google':
              this.$GoogleMap.SetMapStyles(localStorage.getItem('theme'))
              break;
            case 'Leaflet':
              break;
            default:
              break;
          }
          // console.log(this.$Global.ChangeLangNum)
          //有切換語系 have change Lang
          // if(this.$Global.ChangeLangNum != 0){
          //   // setTimeout(() => {
          //   //   this.reload()
          //   //  }, 250);
          //   history.go(0)
          // }
          break;
        case 'cancel':
          
          break;      
        default:
          break;
      }
      // this.$router.back()
      this.$Global.SettingShow = false
    },
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.SettingBox .SettingBoxHeader{
  background-color: #00C768;
  color: white;
  border-radius: 15px 15px 0 0;
  height: 50px;
}
h1, h2 {
  font-weight: normal;
}
ul {
  list-style-type: none;
  padding: 0;
}
li {
  display: inline-block;
  margin: 0 10px;
}
a {
  color: #42b983;
}
</style>



// WEBPACK FOOTER //
// src/components/Setting.vue